export default "https://shopfront-cdn.tekoapis.com/_next/static/images/terminal-picker-336e66814eaacbc1c453155e0754cd27.png";